import React from 'react';
import { UserContext } from "../contexts/UserContext";
import { homeDataService } from "../services/HomeDataService";
import {HomeDataContext} from "../contexts/HomeDataContext";

import { useParams } from 'react-router-dom';

const TourPayment = () => {

    let { tourid } = useParams();

    const { homeDataState, dispatch } = React.useContext(HomeDataContext);

    // Validate and use the subscription ID


    // Use effect to trigger the validation and payment process
    React.useEffect(() => {
        if (dispatch) {
           
	
                // Await the result of the getStory function
            homeDataService.generatePaymentLink(dispatch, tourid);
        
        
            
        }
    }, [dispatch, tourid]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-200">
            <div className="flex flex-col items-center space-y-8 p-10">
                {/* Your UI components */}
            </div>
        </div>
    );
}

export default TourPayment;